// getters must be a function
const getters = {
  noViewed: state => state.noViewed.noViewed
};
export default getters;
